import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Topbar.css';

const Topbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const handleSettings = () => {
    navigate('/admin/settings');
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="admin-topbar">
      {/* Left Section - Search */}
      <div className="topbar-left">
        <div className="search-container">
          <i className="fas fa-search"></i>
          <input 
            type="text" 
            placeholder="Search..." 
            className="search-input"
          />
        </div>
      </div>

      {/* Right Section - Notifications & Profile */}
      <div className="topbar-right">
        {/* Notifications */}
        <div className="notification-icon">
          <i className="fas fa-bell"></i>
          <span className="notification-badge">3</span>
        </div>

        {/* Messages */}
        <div className="message-icon">
          <i className="fas fa-envelope"></i>
          <span className="message-badge">5</span>
        </div>

        {/* Profile Dropdown */}
        <div className="profile-dropdown" ref={dropdownRef}>
          <div 
            className="profile-trigger"
            onClick={toggleDropdown}
          >
            <img 
              src="/images/admin-avatar.jpg" 
              alt="Admin" 
              className="profile-image"
            />
            <div className="profile-info">
              <h4>Admin User</h4>
              <p>Administrator</p>
            </div>
            <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'}`}></i>
          </div>

          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div 
                className="dropdown-item" 
                onClick={(e) => {
                  e.stopPropagation();
                  handleSettings();
                }}
              >
                <i className="fas fa-cog"></i>
                <span>Settings</span>
              </div>
              <div 
                className="dropdown-item" 
                onClick={(e) => {
                  e.stopPropagation();
                  handleLogout();
                }}
              >
                <i className="fas fa-sign-out-alt"></i>
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
